<template>
  <div class="sm-live-answering">
    <live-receptionist
      :plans="receptionistPlans"
      :currentPlan="currentPlan"
      :users="additionalUsers"
      :isCustomer="true"
      @subscribe="handleSubscribe"
      @cancel="handleCancel"
      @add-users="addAdditionalUsers"
      @update-user="updateAdditionalUser"
      @delete-user="deleteAdditionalUser"
    />
    <extras-svgs />

    <sm-spinner :show="showSpinner" />

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="popup.type == 'select-plan' ? 'xlarge' : 'default'"
      :class="'sm-live-answering__popup'"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <!-- <confirm-block
          v-if="popup.type == 'cancel-plan'"
          :title="'Are you sure you want to cancel SpherePhone Live Receptionist?'"
          :text="currentPlan && additionalUsers.length ? 'All additional Live Answering recipients will be released.' : ''"
          :confirmType="'error'"
          :confirmText="'Cancel plan'"
          :cancelText="'Return'"
          @cancel="popup.isOpen = false"
          @confirm="confirmCancel"
        /> -->
        <div 
          v-if="popup.type == 'cancel-plan'"
          class="sm-live-answering__popup-cancel"
        >
          <h4>Cancel Subscription Request</h4>
          <h5
            v-if="provider.name"
            class="sm-txt-capitalize"
          >{{provider.name}}</h5>
          <p>
            <include-svg :name="'icon-phone'" />
            <a
              :href="`tel:${provider.phone}`"
            >{{provider.phone}}</a>
          </p>
          <p>
            <include-svg :name="'icon-mail'" />
            <a
              :href="`mailto:${provider.email}`"
            >{{provider.email}}</a>
          </p>
          <!-- <p class="sm-h4 sm-txt-center sm-extra-cancel-popup__title">Are you sure you want to cancel SpherePhone Live Receptionist?</p>
          <btn-block 
            :class="'sm-btn--error sm-extra-cancel-popup__btn'" 
            :text="'Cancel immidiately'"
            @click="unsubscribe"
          />
          <btn-block 
            class="disabled"
            :class="'sm-btn--error sm-extra-cancel-popup__btn'" 
            :text="'Cancel after end of period'" 
          /> -->
        </div>
        <confirm-block
          v-else-if="popup.type == 'subscribe'"
          :text="`Do you want to switch to ${popup.item.name}`"
          @cancel="popup.isOpen = false"
          @confirm="confirmSubscribe(popup.item.id)"
        />
      </template>
    </popup-block>
  </div>
</template>

<script>
import LiveReceptionist from '@/components/account/LiveReceptionist';
import ExtrasSvgs from '@/views/customer/pages/account/components/extras-components/Extras-svgs';
import Spinner from '@/components/Spinner';
import { mapActions, mapGetters } from 'vuex';
import Popup from '@/components/Popup';
import Confirm from '@/components/Confirm';

export default {
  name: 'live-answering',
  components: {
    'live-receptionist': LiveReceptionist,
    'extras-svgs': ExtrasSvgs,
    'sm-spinner': Spinner,
    'popup-block': Popup,
    'confirm-block': Confirm
  },
  data() {
    return {
      showSpinner: false,
      receptionistPlans: [],
      currentPlan: null,
      additionalUsers: [],
      popup: {
        isOpen: false,
        type: '', // values: subscribe, cancel-plan
        item: null
      }
    };
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
      provider: 'provider'
    })
  },
  created() {
    this.showSpinner = true;
    this.getReceptionistList()
      .then(res => {
        this.receptionistPlans = res.plans;

        if (Object.keys(this.userAccount).length)
          this.setCurrentPlan();
        
        this.showSpinner = false;
      });
  },
  methods: {
    ...mapActions({
      getReceptionistList: 'account/getReceptionistList',
      subToReceptionist: 'account/subToReceptionist',
      unsubFromReceptionist: 'account/unsubFromReceptionist',
      getLiveRecipients: 'customers/getLiveRecipients',
      addLiveRecipient: 'customers/addLiveRecipient',
      updateLiveRecipient: 'customers/updateLiveRecipient',
      deleteLiveRecipient: 'customers/deleteLiveRecipient',
    }),
    setCurrentPlan() {
      if (this.userAccount.live_receptionist_plan_id) {
        this.showSpinner = true;
        this.currentPlan = this.receptionistPlans.find(plan => plan.id == this.userAccount.live_receptionist_plan_id);

        this.getLiveRecipients()
          .then(res => {
            if (res && res.additional_live_receptionist_accounts)
              this.additionalUsers = res.additional_live_receptionist_accounts;

            this.showSpinner = false;
          });
      } else {
        this.currentPlan = null;
        this.additionalUsers = [];
      }
    },
    handleSubscribe(item) {
      this.popup = {
        type: 'subscribe',
        item,
        isOpen: true
      }
    },
    confirmSubscribe(id) {
      this.subscribe(id);
      // TEMP - customer can't switch plan
      // this.showSpinner = true;

      // if (this.currentPlan) { // clear current plan before switch to other plan
      //   this.unsubFromReceptionist()
      //     .then(() => {
      //       this.currentPlan = null;
      //       this.additionalUsers = [];
      //       this.popup.isOpen = false;
      //       this.subscribe(id);
      //     })
      //     .catch(e => {
      //       this.handleError(e);
      //       this.popup.isOpen = false;
      //       this.showSpinner = false;
      //     });
      // } else {
      //   this.subscribe(id);
      // }
    },
    subscribe(id) {
      this.showSpinner = true;
      this.subToReceptionist(id)
        .then(() => {
          this.currentPlan = this.receptionistPlans.find(plan => plan.id == id);
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
        .catch(e => {
          this.handleError(e);
          this.showSpinner = false;
        });
    },
    handleCancel() {
      this.popup.type = 'cancel-plan';
      this.popup.isOpen = true;
    },
    // confirmCancel() {
    //   this.showSpinner = true;
    //   this.unsubFromReceptionist()
    //     .then(() => {
    //       this.currentPlan = null;
    //       this.additionalUsers = [];
    //       this.popup.isOpen = false;
    //       this.showSpinner = false;
    //     })
    //     .catch(e => {
    //       this.handleError(e);
    //       this.popup.isOpen = false;
    //       this.showSpinner = false;
    //     });
    // },
    handleError(e) {
      let error = e.response;

      if (!error)
        return;

      if (
        error.status == 422 &&
        error.data &&
        error.data.errors &&
        error.data.errors.base
      ) {
        this.popup.type = 'error';
        this.popup.item = {
          title: 'Error!',
          text: error.data.errors.base[0]
        };
        this.popup.isOpen = true;
      }
    },
    async addAdditionalUsers(users) {
      if (!users.length)
        return;

      this.showSpinner = true;

      for (const user of  users) {
        try {
          await this.addLiveRecipient(user)
            .then(res => {
              if (this.currentPlan && res && res.additional_live_receptionist_account)
                this.additionalUsers.push(res.additional_live_receptionist_account);
            });
        } catch(e) {
          console.log('can\'t add user', e, user);
        }
      }

      this.popup.isOpen = false;
      this.showSpinner = false;
    },
    updateAdditionalUser(data) {
      this.showSpinner = true;

      this.updateLiveRecipient({
        id: data.id,
        params: {
          first_name: data.first_name,
          last_name: data.last_name
        }
      })
        .then(res => {
          if (res && res.additional_live_receptionist_account) {
            let arr = [...this.additionalUsers];
            let index = arr.findIndex(item => item.id == data.id);

            arr[index] = res.additional_live_receptionist_account;
            this.additionalUsers = arr;
          }

          this.showSpinner = false;
        })
    },
    deleteAdditionalUser(id) {
      this.showSpinner = true;

      this.deleteLiveRecipient(id)
        .then(res => {
          let index = this.additionalUsers.findIndex(item => item.id == id);

          this.additionalUsers.splice(index, 1);

          if (!this.additionalUsers.length)
            this.popup.isOpen = false;

          this.showSpinner = false;
        })
    }
  }
}
</script>

<style lang="scss">
  .sm-live-answering {
    position: relative;
    
    &__popup {
      &-cancel {
        & > h5 {
          margin-top: 20px;
        }

        & > p {
          display: flex;
          margin-top: 10px;
          align-items: center;
          
          & > svg {
            width: 28px;
            height: 28px;
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>